<div *ngIf="visivel" class="nk-block-head nk-block-head-lg wide-sm mb-4">
    <div class="nk-block-head-content">
        <div class="nk-block-head-sub">
            <a class="back-to" href="javascript:history.go(-1)">
                <em class="icon ni ni-arrow-left"></em><span>{{'back'|translate}}</span>
            </a>
        </div>
    </div>
</div>